// removed by extract-text-webpack-plugin
module.exports = {"LanguageSwitcher":"LanguageSwitcher","LanguageItem":"LanguageItem","Active":"Active","popover-lang":"popover-lang","LanguageDropdown":"LanguageDropdown","arrow":"arrow"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/LanguageSwitcher/styles.scss
// module id = 1759
// module chunks = 10